import React, { useEffect, useState } from 'react';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import gallery from "../../api/gallery";
import * as Yup from "yup";
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';

import { ErrorMessage, Field, Form, Formik } from "formik";
let validationSchema = Yup.object({
   domain: Yup.string().required("Website url is required"),
});

function Domain({ data }) {
   const [ip, setIp] = useState("XXX.XXX.XX")
   let dispatch = useDispatch();

   useEffect(() => {
      getIpAddress()
   }, [])

   const getIpAddress = async () => {
      let res = await AppApi.getIpAddress("https://api.myvirtual.store") 
      if (res?.data?.Answer) {
         let ipDetail = res?.data?.Answer[0]; 
         if (ipDetail?.data) {
            setIp(ipDetail?.data)
         }
      }
   }

   return (
      <>
         <h3 className="card-title mb-4">Connect Your Domain</h3>
         <p className="card-text">
            To connect your domain, please follow the steps below:
         </p>
         <ol>
            <li>
               Add the following IP address to your domain's DNS <strong>A Record: {ip}</strong>
            </li>
            <li>
               Once the DNS record is updated, return to this section and provide your domain URL in the field below.
            </li>
         </ol>
         <div className="alert alert-info">
            Note: It may take up to 24-48 hours for DNS changes to propagate.
         </div>
         <Formik
            initialValues={{
               domain: data?.domain || "",
            }}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
               setSubmitting(true);
               try {
                  let res = "";
                  if (data?._id) {
                     res = await AppApi.updateProfile(values);
                  }
                  if (res?.data?.error == false) {
                     toast.success(res?.data?.msg);
                     dispatch(Actions.addProfile(res?.data?.data));
                  }
                  setSubmitting(false);
               } catch (error) {
                  console.log(error.message);
                  setSubmitting(false);
               }
            }}
         >
            {({ isSubmitting, values, errors, setFieldValue }) => (
               <Form>
                  <div className="form-group mt-1">
                     <label>Domain Url</label>
                     <Field
                        name="domain"
                        type="text"
                        disabled={true}
                        className="form-control rounded"
                        placeholder="location cost"
                     />
                     <ErrorMessage component="small" className='text-danger' name="websiteUrl" />
                  </div>
                  <div className="p-0 mt-5 text-left col-sm-12">
                     <div className="mb-1 form-group d-flex justify-content-end">
                        <button type="submit"
                           // disabled={isSubmitting} 
                           disabled={true}
                           className=" btn rounded-0 btn-dark">{isSubmitting ? "Loading..." : data?._id ? "Update" : "Update"}</button>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
         <div className="alert alert-warning">
            <strong>Warning:</strong> This feature is currently under development. While you can proceed with the steps, full functionality may not be available yet.
         </div>
      </>
   )
}

export default Domain